import { render, staticRenderFns } from "./BBSwitch.vue?vue&type=template&id=857a5010"
import script from "./BBSwitch.vue?vue&type=script&lang=js"
export * from "./BBSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('857a5010')) {
      api.createRecord('857a5010', component.options)
    } else {
      api.reload('857a5010', component.options)
    }
    module.hot.accept("./BBSwitch.vue?vue&type=template&id=857a5010", function () {
      api.rerender('857a5010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/content/BBForm/BBSwitch.vue"
export default component.exports